import React, { useEffect } from 'react'

import { HiOutlinePhone } from 'react-icons/hi'
import { MdAutorenew } from 'react-icons/md'
import PlanCardSkeleton from '../DashboardPage/PlanCardSkeleton'
import customerStore from '../../datastore/CustomerStore'
import { getContact } from '../../utils/getContact'
import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import theme from '../../global/theme'

const spin = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`

const slideDown = keyframes`
  from { opacity: 0; transform: translateY(-12px); }
  to   { opacity: 1; transform: translateY(0); }
`

const Banner = styled.div`
  max-width: 1200px;
  width: 100%;
  border-radius: 16px;
  background: linear-gradient(135deg, ${theme.colors.primary} 0%, #3a4baa 100%);
  padding: 28px 36px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 24px;
  box-shadow: 0 8px 32px rgba(34, 44, 105, 0.22);
  animation: ${slideDown} 0.4s ease;

  @media screen and (max-width: 700px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px 20px;
    gap: 16px;
  }
`

const IconCircle = styled.div`
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    animation: ${spin} 2s linear infinite;
    color: #fff;
    font-size: 26px;
  }

  @media screen and (max-width: 700px) {
    width: 44px;
    height: 44px;
    svg {
      font-size: 22px;
    }
  }
`

const TextBlock = styled.div`
  flex: 1;

  h3 {
    margin: 0 0 6px;
    font-size: 18px;
    font-weight: 700;
    color: #fff;
    letter-spacing: 0.2px;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.82);
    line-height: 1.55;
    font-weight: 500;
  }

  @media screen and (max-width: 700px) {
    h3 {
      font-size: 16px;
    }
    p {
      font-size: 13px;
    }
  }
`

const PhoneLink = styled.a`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 22px;
  background: #fff;
  color: ${theme.colors.primary};
  border-radius: 50px;
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
  transition:
    transform 0.15s,
    box-shadow 0.15s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.18);
  }

  svg {
    font-size: 16px;
    flex-shrink: 0;
  }

  @media screen and (max-width: 700px) {
    width: 100%;
    justify-content: center;
    font-size: 14px;
  }
`

const QuotesBanner: React.FC = () => {
  const phone = getContact(customerStore.getBrandName())
  return (
    <Banner>
      <IconCircle>
        <MdAutorenew />
      </IconCircle>

      <TextBlock>
        <h3>Your plans are getting ready!</h3>
        <p>
          We're finding the best options for you — this only takes a moment. Our
          team will also reach out shortly to help you find the right plan.
        </p>
      </TextBlock>

      <PhoneLink href={`tel:${phone}`} className='phone-number-fade'>
        <HiOutlinePhone />
        {phone}
      </PhoneLink>
    </Banner>
  )
}

const ContactCard: React.FC = () => {
  useEffect(() => {
    window.Invoca && window.Invoca.PNAPI.run()
  }, [])

  return <PlanCardSkeleton topBanner={<QuotesBanner />} />
}

export default ContactCard
